module.exports = "/_next/static/images/2874037f64d347de56c041c9c952b091-girl-holding-phone@3x.jpg.webp";